// `useCompleteProvisioning` — POST /api/public/auth/provisioning/complete.
//
// Mutation rather than query: each call mints a server-side state
// change (Firebase Auth user create/update + token consumption) and
// is non-idempotent at the user level (a second attempt with the
// same token returns 410 by design, not the original 200).
//
// The hook returns the bare TanStack mutation result; the page reads
// `mutation.error` (an ApiError) to render success vs failure UX.
// We intentionally do NOT pre-translate error codes here — the page
// owns the copy.

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';
import type {
  CompleteProvisioningPayload,
  CompleteProvisioningResponse,
} from '../types';

export function useCompleteProvisioning(): UseMutationResult<
  CompleteProvisioningResponse,
  Error,
  CompleteProvisioningPayload
> {
  return useMutation<
    CompleteProvisioningResponse,
    Error,
    CompleteProvisioningPayload
  >({
    mutationFn: (payload) =>
      apiClient.post<CompleteProvisioningResponse>(
        '/api/public/auth/provisioning/complete',
        payload,
      ),
  });
}
